import type { ChannelItem, PaymentChannelType } from './types';

interface Props {
  channels: ChannelItem[];
  selectedId: string;
  onSelect: (id: string) => void;
}

/** 渠道类型 → 图标与配色。default 兜住库里的历史脏值，不至于渲染成空白卡片 */
function channelIcon(type: PaymentChannelType): { icon: string; color: string } {
  switch (type) {
    case 'alipay':
      return { icon: 'ri-alipay-line', color: 'text-blue-500' };
    case 'wechat':
      return { icon: 'ri-wechat-pay-line', color: 'text-green-500' };
    case 'bank_transfer':
      return { icon: 'ri-bank-card-line', color: 'text-gray-600' };
    default:
      return { icon: 'ri-wallet-3-line', color: 'text-gray-500' };
  }
}

/**
 * 支付方式选择器：按后端下发的可用渠道渲染卡片。
 * 受控组件；无可用渠道时展示引导提示（联系管理员配置）。
 */
export function PaymentMethodSelector({ channels, selectedId, onSelect }: Props) {
  if (channels.length === 0) {
    return (
      <div className="bg-orange-50 border border-orange-200 rounded-lg px-4 py-3 text-xs text-orange-700">
        <i className="ri-error-warning-line mr-1" />
        暂未配置支付方式，请联系管理员在后台添加支付渠道后再进行升级
      </div>
    );
  }

  return (
    <div>
      <p className="text-sm font-semibold text-gray-700 mb-3">选择支付方式</p>
      <div className="grid grid-cols-3 gap-2.5">
        {channels.map((ch) => {
          const { icon, color } = channelIcon(ch.channelType);
          const selected = selectedId === ch.id;
          return (
            <button
              key={ch.id}
              type="button"
              onClick={() => onSelect(ch.id)}
              className={`flex flex-col items-center gap-1 px-3 py-3 rounded-xl border-2 cursor-pointer transition-all ${
                selected ? 'border-amber-400 bg-amber-50' : 'border-gray-200 bg-gray-50 hover:border-gray-300'
              }`}
            >
              <i className={`text-xl ${icon} ${color}`} />
              <span className="text-xs text-gray-600 text-center leading-tight">{ch.channelName}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
